export const headersPatient = ['ID', 'Nome', 'Tipo de usuário']

export const headersEvents = ['Data/Hora', 'Descrição', 'Detalhes']
